export default function (number, c, d, t) {
    let n = number;
    c = Math.abs(c);
    c = isNaN(c) ? 2 : c;
    d = d === undefined ? '.' : d;
    t = t === undefined ? ',' : t;
    const s = n < 0 ? '-' : '';
    const i = `${parseInt(n = Math.abs(+n || 0).toFixed(c), 8)}`;
    let j = i.length;
    j = (j) > 3 ? j % 3 : 0;
    return s + (j ? i.substr(0, j) + t : '') + i.substr(j).replace(/(\d{3})(?=\d)/g, '$1' + t) + (c ? d + Math.abs(n - i).toFixed(c).slice(2) : '');
}



// WEBPACK FOOTER //
// ./scripts/util/numberFormat.js